import { render, staticRenderFns } from "./BuildUsageCodeTable.vue?vue&type=template&id=dc712580&scoped=true"
import script from "./BuildUsageCodeTable.vue?vue&type=script&lang=js"
export * from "./BuildUsageCodeTable.vue?vue&type=script&lang=js"
import style0 from "./BuildUsageCodeTable.vue?vue&type=style&index=0&id=dc712580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc712580",
  null
  
)

export default component.exports